import "./app.css";
import "react-toastify/dist/ReactToastify.css";
import { themeModeStore } from "@app/stores/theme.store.ts";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { useStore } from "@tanstack/react-store";
import { useMemo } from "react";
import { ToastContainer } from "react-toastify";
import useAuth from "./hooks/use-auth.ts";
import { routeTree } from "./routeTree.gen.ts";
import { Theme } from "./theme.ts";

const router = createRouter({
    routeTree,
    context: { isAuthenticated: false, isAdmin: false, isManager: false },
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}

function App() {
    const { isAuthenticated, isAdmin, isManager } = useAuth();

    const themeMode = useStore(themeModeStore);
    const theme = useMemo(() => (themeMode == "light" ? Theme.light : Theme.dark), [themeMode]);

    return (
        <ThemeProvider theme={theme}>
            <ToastContainer closeOnClick theme={themeMode} />
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <RouterProvider router={router} context={{ isAuthenticated, isAdmin, isManager }} />
            </LocalizationProvider>
        </ThemeProvider>
    );
}

export default App;
